import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Drawer } from '@root/shared/ui-kit'

import { GasSettingsForm } from '../../common/gas-settings/gas-settings-form'

import type { TransferGasSettingsReatom } from '../../../atoms/transfer-fee-reatom'
import type { DrawerProps } from '@root/shared/ui-kit'

type WalletDepositDrawerProps = {
  gasSettingsModel: TransferGasSettingsReatom
} & Pick<DrawerProps, 'onOpenChange' | 'open'>

export const GasSettingsDrawer: React.FC<WalletDepositDrawerProps> = ({
  open,
  onOpenChange,
  gasSettingsModel,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      title={t('gas-settings.change-gas-settings')}
    >
      <Form
        gasSettingsModel={gasSettingsModel}
        onDone={() => {
          onOpenChange?.(false)
        }}
      />
    </Root>
  )
}

const Root = styled(Drawer)``

const Form = styled(GasSettingsForm)`
  padding-block: 8px 38px;
`
